import React, { useState } from 'react'
import { Section } from 'newComponents'
import './styles.scss'

const FaqAccordion = (props) => {
  const { data } = props
  const { primary, items } = data

  const { title } = primary

  const [openIndexes, setOpenIndexes] = useState([0])

  const titleHtml = title?.html

  const toggleFaq = (event, index) => {
    event.preventDefault()
    const indexOfExisting = openIndexes.indexOf(index)
    const clonedArr = [...openIndexes]
    if (indexOfExisting === -1) {
      clonedArr.push(index)
    } else {
      clonedArr.splice(indexOfExisting, 1)
    }
    setOpenIndexes(clonedArr)
  }

  const escapeDoubleQuotes = (str) => str.replace(/\\([\s\S])|(")/g, '\\$1$2')

  const schema = `
  <script type="application/ld+json">
    {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      ${items.map(
    (item) => `
        {
          "@type": "Question",
          "name": "${item.question.text}",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "${escapeDoubleQuotes(item.answer.html)}"
          }
        }`
      )}]
    }
    </script>
  `

  return (
    <Section className="faq">
      {titleHtml && <div className="faq-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
      <div className="faq-accordion">
        {items.map((item, index) => (
          <FaqItem
            key={item.question.text}
            toggleFaq={toggleFaq}
            openIndexes={openIndexes}
            itemIndex={index}
            {...item}
          />
        ))}
      </div>
      <div dangerouslySetInnerHTML={{ __html: schema }} />
    </Section>
  )
}

const FaqItem = (props) => {
  const { question, answer, toggleFaq, openIndexes, itemIndex } = props

  const active = openIndexes.indexOf(itemIndex) !== -1

  return (
    <div className={`faq-accordion-item ${active ? 'active' : 'inactive'}`}>
      <a className="faq-accordion-question" href="#toggle" onClick={(event) => toggleFaq(event, itemIndex)}>
        <span className="faq-accordion-question-title">{question.text}</span>
        <button className={`plus-minus ${active ? 'active' : 'inactive'}`} type="button">
          Toggle
        </button>
      </a>
      <div className="faq-accordion-answer" dangerouslySetInnerHTML={{ __html: answer.html }} />
    </div>
  )
}

export default FaqAccordion
